'use client';

import { forwardRef, useRef, useState } from 'react';
import { isNotNullOrUndefinedorEmpty } from '@next-app/utils/common-utils';
import Conditional from '@next-app/components/Conditional';
import parse from 'html-react-parser';

interface LLInputProps {
  labelText?: string | React.JSX.Element | React.JSX.Element[];
  automationId?: string;
  testid?: string;
  onChange?: Function;
  value?: string | number;
  errorMsg?: string;
  customClass?: string;
  maxLength?: number;
  isDisabled?: boolean;
  fsMask?: boolean;
  name?: string;
}

const LLInput = forwardRef<
  HTMLInputElement,
  React.InputHTMLAttributes<HTMLInputElement> & LLInputProps
>(
  (
    {
      labelText,
      type,
      id,
      automationId,
      testid,
      onChange,
      placeholder,
      errorMsg = '',
      value,
      customClass,
      autoComplete = 'on',
      maxLength,
      name,
      isDisabled,
      fsMask = false,
      onBlur,
      pattern,
      onKeyDown,
      onKeyUp,
      onFocus,
    },
    ref,
  ) => {
    const [showPassword, setShowPassword] = useState(false);
    const innerRef = useRef<HTMLInputElement>(null);
    const inputRef = (ref as React.RefObject<HTMLInputElement>) || innerRef;

    let classList = ['form-control'];
    if (!labelText) {
      labelText = placeholder;
    }
    if (customClass) {
      classList.push(customClass);
    }
    if (fsMask) {
      classList.push('fs-mask');
    }
    if (errorMsg) {
      classList.push('border-danger');
    }

    return (
      <>
        <div
          className={`form-floating ${type === 'password' ? 'position-relative' : ''}`}
        >
          <input
            ref={inputRef}
            type={showPassword ? 'text' : type}
            className={classList.join(' ')}
            id={id}
            placeholder={placeholder}
            automation-id={automationId}
            data-testid={testid}
            onChange={onChange}
            value={value}
            autoComplete={autoComplete}
            maxLength={maxLength}
            name={name}
            disabled={isDisabled}
            onBlur={onBlur}
            pattern={pattern}
            onKeyDown={onKeyDown}
            onKeyUp={onKeyUp}
            onFocus={onFocus}
          />
          <Conditional if={isNotNullOrUndefinedorEmpty(labelText)}>
            <label htmlFor={id}>{labelText}</label>
          </Conditional>

          <Conditional if={type === 'password'}>
            <i
              className={`ls-icon eye ll-fs-24 d-flex position-absolute fst-normal cursor-pointer ${showPassword ? 'icn-pw-show' : 'icn-pw-hide'}`}
              role="button"
              onClick={() => setShowPassword((prevState) => !prevState)}
            ></i>
          </Conditional>
        </div>
        <Conditional if={isNotNullOrUndefinedorEmpty(errorMsg)}>
          <div className="invalid-feedback d-block">
            <p dangerouslySetInnerHTML={{ __html: parse(errorMsg) }}></p>
          </div>
        </Conditional>
      </>
    );
  },
);
LLInput.displayName = 'LLInput';
export default LLInput;
